import { create } from 'zustand';
import { TableOfContentsEntry } from '../types/tableOfContents';

interface SidebarStore {
  isSidebarCollapsed: boolean;
  areSidebarItemsCollapsed: boolean;
  tableOfContents: TableOfContentsEntry[];
  setTableOfContents: (tableOfContents: TableOfContentsEntry[]) => void;
  visibleSidebarElements: {
    [key: string]: boolean;
  };
  toggleIsSidebarCollaped: (forceValue?: boolean) => void;
  toggleAreSidebarItemsCollapsed: (forceValue?: boolean) => void;
  setVisibleSidebarElements: (visibleSidebarElements: {
    [key: string]: boolean;
  }) => void;
}

const localStorageValueToBoolean = (value: string | null) => {
  if (value === 'true') {
    return true;
  }
  if (value === 'false') {
    return false;
  }
  return false;
};

export const useSidebarStore = create<SidebarStore>(set => ({
  tableOfContents: [],
  setTableOfContents: tableOfContents => set({ tableOfContents }),
  isSidebarCollapsed: localStorageValueToBoolean(
    window.localStorage.getItem('sidebar-is-collapsed'),
  ),
  areSidebarItemsCollapsed: localStorageValueToBoolean(
    window.localStorage.getItem('sidebar-items-are-collapsed'),
  ),
  visibleSidebarElements: {},
  setVisibleSidebarElements: visibleSidebarElements =>
    set(state => ({
      visibleSidebarElements: {
        ...state.visibleSidebarElements,
        ...visibleSidebarElements,
      },
    })),
  toggleAreSidebarItemsCollapsed: forceValue =>
    set(state => ({
      areSidebarItemsCollapsed: forceValue
        ? forceValue
        : !state.areSidebarItemsCollapsed,
    })),
  toggleIsSidebarCollaped: forceValue =>
    set(state => ({
      isSidebarCollapsed: forceValue ? forceValue : !state.isSidebarCollapsed,
    })),
}));
